export default __webpack_public_path__ + "static/media/snuffles.a2ce51e2.png";